// 销售管理
export default [
    {
      path: '/marketingClewConfig',
      name: 'marketingClewConfig',
      meta: {
        requireAuth: true,
        keepAlive: true
      },
      component: (resolve) => {
        require(['@/views/saleConfig/marketingClewConfig.vue'], resolve)
      }
    },
    {
      path: '/marketingConfig',
      name: 'marketingConfig',
      meta: {
        requireAuth: true,
        keepAlive: true
      },
      component: (resolve) => {
        require(['@/views/saleConfig/marketingConfig.vue'], resolve)
      }
    },
    {
      path: '/annualRuleConfig',
      name: 'annualRuleConfig',
      meta: {
        requireAuth: true,
        keepAlive: true
      },
      component: (resolve) => {
        require(['@/views/saleConfig/annualRuleConfig.vue'], resolve)
      }
    },
    {
      path: '/purchasePlan',
      name: 'purchasePlan',
      meta: {
        requireAuth: true,
        keepAlive: true
      },
      component: (resolve) => {
        require(['@/views/saleConfig/purchasePlan.vue'], resolve)
      }
    },
    {
      path: '/pilotConfig',
      name: 'pilotConfig',
      meta: {
        requireAuth: true,
        keepAlive: true
      },
      component: (resolve) => {
        require(['@/views/saleConfig/pilotConfig.vue'], resolve)
      }
    }
  
  ]
  


// WEBPACK FOOTER //
// ./src/router/saleConfig.js